import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import packageJSON from '../../../package.json';
import { t } from '../../lang';
import HelperService from '../../services/HelperService';
import TypesService from '../../services/TypesService';
import Icon, { Icons } from '../Icon/Icon';
import ListItem from '../ListItem';
import './HistoryItem.scss';

const ARROW_ICON_SIZE = 28;
const CREDIT_CURRENCY = packageJSON?.creditCurrency ?? 'Credits';
const CurrenciesById = TypesService.CurrenciesById;
const transactionDestinationIsons = TypesService.TransactionDestinationIsons;

const HistoryItem = ({ transaction, lastItem = false, onClick = () => {} }) => {
	const currencyData = CurrenciesById[transaction.CurrencyId];
	const directionName = TypesService.TransactionDirectionByType[transaction.TransactionType];
	const condition = TypesService.TransactionStatusesById[transaction.TransactuinStatus].condition;

	const getIconByType = () => {
		const iconName = transactionDestinationIsons[transaction.destinationType] || 'ARROW_BOLD';
		const rotateArrowIcon = directionName === 'Received';
		return (
			<div className='HistoryItem__icon-box'>
				<Icon
					className={classNames('HistoryItem__arrow', { 'HistoryItem__arrow-rotate': rotateArrowIcon })}
					type={Icons[iconName]}
					height={ARROW_ICON_SIZE}
					width={ARROW_ICON_SIZE}
				/>
			</div>
		);
	};

	const getLabelByStatus = () => {
		const iconByCondition = {
			waiting: 'CLOCK_FILL',
			failed: 'XMARK_CIRCLE_FILL',
		};

		if (!condition) return null;
		return (
			<div className={classNames('HistoryItem__label-box', 'HistoryItem__label-' + condition)}>
				<Icon className={'HistoryItem__label-icon-' + condition} type={Icons[iconByCondition[condition]]} />
			</div>
		);
	};

	const onSelect = () => onClick(transaction);

	const amountSign = transaction.AmountUsd > 0 ? '+' : transaction.AmountUsd < 0 ? '-' : '';

	const trDate = transaction.Created || transaction.Date || '';
	const transactionDate =
		trDate
			.split('T')[0]
			.split('-')
			.reverse()
			.map(i => i.slice(-2))
			.join('.') +
		' ' +
		trDate.split('T')[1].split('.')[0];

	return (
		<ListItem
			className={classNames('HistoryItem', 'HistoryItem__' + directionName, condition && 'HistoryItem__' + condition)}
			icon={getIconByType(transaction.TransactionType)}
			title={transaction.destinationName || t(directionName)}
			label={getLabelByStatus(transaction.TransactuinStatus)}
			description={transactionDate}
			rightTitle={`${transaction.Amount > 0 ? '+' : ''}${HelperService.FormatCrypto(
				transaction.Amount,
				currencyData.Precision
			)} ${currencyData.Name === 'Credits' ? CREDIT_CURRENCY : currencyData.Name}`}
			rightDescription={amountSign + '$' + HelperService.FormatFiatWithoutCurrency(Math.abs(transaction.AmountUsd))}
			bottomSeparator={!lastItem}
			onSelect={onSelect}
		/>
	);
};

HistoryItem.propTypes = {
	items: PropTypes.array,
	date: PropTypes.string,
	transactionType: PropTypes.number,
	amount: PropTypes.number,
	currencyId: PropTypes.number,
	hideSymbol: PropTypes.bool,
	lable: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default HistoryItem;
